import { FC } from "react";
import { Column } from "../../../containers";
import { AlignItems, JustifyContent } from "../../../containers/types";
import { styles } from "./styles";
import NavHeader from "./nav-header";
import NavItems from "./nav-items";
import NavFooter from "./nav-footer";

const Nav: FC = () => {
  return (
    <Column
      style={styles.container}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Between}
      gap={50}
    >
      <Column style={{ width: "100%" }} gap={50}>
        <NavHeader />
        <NavItems />
      </Column>
      <NavFooter />
    </Column>
  );
};

export default Nav;
